import { FormikValues } from 'formik';

import { User } from '@/types/user';
import { sanitizePhone } from '@utils/profile';

interface SignUpFromForm {
  password: string;
  firstName: string;
  lastName: string;
  email: string;
  communicationsPolicy?: boolean;
  platformCommunications?: boolean;
}
const getSignUpFormValues = (props: FormikValues): SignUpFromForm => {
  const { password, firstName, lastName, email, communicationsPolicy, platformCommunications } = props;

  return {
    password,
    firstName,
    lastName,
    email,
    communicationsPolicy,
    platformCommunications,
  };
};
const buildSignUpParameters = (props: SignUpFromForm) => {
  const { password, firstName: name, lastName, email: mail, platformCommunications } = props;
  const user = {
    username: mail,
    password,
    email: mail,
    name,
    lastName,
    conditions: true,
    dataPolicy: true,
    communicationsPolicy: platformCommunications === true,
  };
  return { user };
};

const buildUpdateUserParameters = (props: { data?: User; telephone: string }) => {
  const { data, telephone } = props;
  const userId = data?.userId;

  const user = {
    telephone: sanitizePhone(telephone),
  };
  return { id: userId, input: { ...user } };
};

const buildUpdateUserProfileParameters = (form: any) => {
  const { id, telephone } = form;

  const user = {
    ...(telephone ? { telephone } : {}),
  };
  return { id, input: { ...user } };
};

const buildSignUpParametersSso = (props: SignUpFromForm) => {
  const { firstName: name, lastName, email: mail, platformCommunications } = props;
  return {
    username: mail,
    name,
    lastName,
    conditions: true,
    communicationsPolicy: platformCommunications === true,
  };
};

function safeParse<T = any>(value: any): T | any {
  if (typeof value !== 'string') return value;

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}
const getUserDataFromContext = (data: any) => {
  if (!data) {
    return {
      username: null,
      name: null,
      lastname: null,
      identifier: null,
    };
  }

  const parsed = safeParse(data);
  const { context, identifier } = parsed;

  const contextParsed = safeParse(context);
  if (contextParsed) {
    const { return_object } = contextParsed;
    const { profile_object } = return_object;
    const { email, first_name, last_name } = profile_object;

    return {
      username: email,
      name: first_name,
      lastname: last_name,
      identifier,
    };
  }
  return {
    username: null,
    name: null,
    lastname: null,
    identifier: null,
  };
};
export {
  buildSignUpParameters,
  getSignUpFormValues,
  buildUpdateUserParameters,
  buildUpdateUserProfileParameters,
  buildSignUpParametersSso,
  getUserDataFromContext,
};
